import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  transform: scale(0.96);\n  transition: all 200ms;\n  z-index: ", ";\n\n  ", "\n\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { withClickOutside } from '../HOCs/withClickOutside';
import styled from '../utils/styling/styled-components';
import { Alignment } from './types';
import { contentAlignmentResolvers, isAlignmentVertical } from './alignment';
var Container = styled.div(_templateObject());
var Overlay = styled.div(_templateObject2(), function (props) {
  return props.zIndex;
}, function (props) {
  return contentAlignmentResolvers[props.alignment](props);
}, function (props) {
  return props.visible && "\n    opacity: 1;\n    pointer-events: auto;\n    transform: scale(1);\n  ";
});
export var PositionComponent = function PositionComponent(props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className
  }, props.children, /*#__PURE__*/React.createElement(Overlay, {
    alignment: props.alignment,
    displayArrow: true,
    gutter: props.gutter,
    offset: props.offset,
    visible: props.visible,
    zIndex: props.zIndex
  }, props.content));
};
/**
 * Generic/reusible positioning component for popovers, tooltips, dropdowns, etc.
 */

export var Position = withClickOutside(function (props) {
  if (props.onOutsideClick) props.onOutsideClick();
})(PositionComponent);
Position.defaultProps = {
  gutter: 20,
  offset: 0,
  zIndex: 999
};
export { Alignment, isAlignmentVertical };